import { Table } from "@/features/Table";
import { r1_documents_columns } from "./columns";

const client = "r1";
const table_name = "r1_documents";

export function R1DocumentsTable() {
  return (
    <Table<Record<string, unknown>, unknown>
      label="R1 documents"
      client={client}
      table_name={table_name}
      columns={r1_documents_columns}
    />
  );
}
